import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useRefundReasons(userId) {
  const { data, _error, mutate } = useSWR(
    userId ? `/refundreasons/` : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    refundReasons: data,
    mutate: mutate,
  };
}

export default useRefundReasons;
